import { ChangeDetectionStrategy, Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Recipient } from 'src/app/models/recipients.model';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
    selector: 'que-sumbissions-menu-item',
    imports: [CommonModule, OverlayModule, TranslateDirective, TranslatePipe],
    templateUrl: './sumbissions-menu-item.component.html',
    styleUrls: ['./sumbissions-menu-item.component.scss']
})
export class SumbissionsMenuItemComponent {
  @Input() recipient?: Recipient;
  @ViewChild('trigger') trigger!: ElementRef;
  #router = inject(Router);

  isMenuOpen = false;
  readonly positonArea = [{
    originX: 'center',
    originY: 'center',
    overlayX: 'end',
    overlayY: 'top',
  }] as ConnectedPosition[];

  openMenu($event: Event) {
    $event.stopPropagation();
    const triggerRect = this.trigger.nativeElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    if (triggerRect.bottom + 200 > viewportHeight) {
      this.positonArea[0].overlayY = 'bottom';
    } else {
      this.positonArea[0].overlayY = 'top';
    }
    this.isMenuOpen = true
  }

  viewSubmission(event?: Event) {
    event?.stopPropagation();
    if (this.recipient?.guidToUser) {
      this.#router.navigate(['viewAnswers', this.recipient.guidToUser, 0]);
    }
  }
}
